import { isNil } from 'mojito/utils';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectRoute,
    selectIsRedirect,
    selectIsInitialized,
} from 'applications/common/stores/router/selectors.js';
import { actions as routerActions } from 'applications/common/stores/router/slice.js';
import { LocationProvider, useLocation, Route } from 'preact-iso';
import Router from 'applications/common/routing/router.js';
import { createPath, parsePath } from 'history';

export default function MainApp({ children }) {
    return (
        <LocationProvider>
            <ApplicationRouter>{children}</ApplicationRouter>
        </LocationProvider>
    );
}

function ApplicationRouter({ children }) {
    const dispatch = useDispatch();
    const location = useLocation();
    const route = useSelector(selectRoute);
    const isRedirected = useSelector(selectIsRedirect);
    const isInitialized = useSelector(selectIsInitialized);

    useEffect(() => {
        dispatch(routerActions.routeInit(location.url));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // When the Redux route changes, navigate preact-iso to match.
    useEffect(() => {
        if (isInitialized && !isNil(route) && route !== location.url) {
            const { pathname, search = '', hash = '' } = parsePath(route);
            const url = createPath({ pathname, search, hash });
            location.route(url, isRedirected);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [route, isRedirected]);

    const onRouteChange = useCallback(
        navUrl => {
            if (route !== navUrl) {
                dispatch(
                    routerActions.routeChange({
                        route: navUrl,
                        previousRoute: route,
                    })
                );
            }
        },
        [dispatch, route]
    );

    return (
        <Router onRouteChange={onRouteChange}>
            <Route path={['/', '/*']} component={ApplicationContent}>
                {children}
            </Route>
        </Router>
    );
}

function ApplicationContent(props) {
    const { children } = props;
    const location = useLocation();
    return children(location);
}
